// target isn't always usable with Shadow DOM
export default (event) => {
  const composedPath = event.composedPath();
  if (composedPath && composedPath[0]) {
    return composedPath[0];
  }
  return event.originalTarget || event.target;
};
